document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-protein-calculator]').forEach((calculator) => {
    const form = calculator.querySelector('[data-protein-form]');
    if (!form) return;

    const outputRange = calculator.querySelector('[data-protein-range]');
    const outputTarget = calculator.querySelector('[data-protein-target]');
    const outputPerMeal = calculator.querySelector('[data-protein-per-meal]');
    const outputPerKg = calculator.querySelector('[data-protein-per-kg]');
    const outputCalories = calculator.querySelector('[data-protein-calories]');
    const outputNote = calculator.querySelector('[data-protein-note]');

    const goalRanges = {
      wellbeing: [1.0, 1.2],
      active: [1.2, 1.6],
      muscle: [1.6, 2.2],
      fatloss: [1.8, 2.4],
    };

    const activityMultipliers = {
      sedentary: 1.2,
      light: 1.375,
      moderate: 1.55,
      active: 1.725,
      very_active: 1.9,
    };

    function value(name) {
      const field = form.elements[name];
      if (!field) return '';
      if (field instanceof RadioNodeList) return field.value;
      return field.value;
    }

    function clamp(number, min, max) {
      return Math.min(max, Math.max(min, number));
    }

    function calculate() {
      const gender = value('gender') || 'male';
      const goal = value('goal') || 'active';
      const activity = value('activity') || 'light';
      const weight = Number(value('weight')) || 0;
      const height = Number(value('height')) || 0;
      const age = Number(value('age')) || 0;

      if (!weight || !height || !age) return;

      const baseRange = goalRanges[goal] || goalRanges.active;
      const bmr = gender === 'female'
        ? 10 * weight + 6.25 * height - 5 * age - 161
        : 10 * weight + 6.25 * height - 5 * age + 5;
      const tdee = bmr * (activityMultipliers[activity] || activityMultipliers.light);
      const energyPerKg = tdee / weight;
      const ageAdjustment = age >= 65 ? 0.1 : age >= 50 ? 0.05 : 0;
      const energyAdjustment = energyPerKg >= 42 ? 0.1 : energyPerKg <= 27 ? -0.05 : 0;
      const bmi = weight / ((height / 100) * (height / 100));

      let calculationWeight = weight;
      let note = 'Tulos on käytännönläheinen arvio. Proteiinin tarve kannattaa ajatella vaihteluvälinä, ei yhtenä millintarkkana numerona.';

      if (goal === 'fatloss' && bmi >= 30) {
        const referenceWeight = 25 * ((height / 100) * (height / 100));
        calculationWeight = referenceWeight + (weight - referenceWeight) * 0.4;
        note = 'Koska paino suhteessa pituuteen on korkea ja tavoitteena on rasvanpoltto, laskuri käyttää maltillisempaa laskentapainoa liian suuren proteiinitavoitteen välttämiseksi.';
      }

      let minFactor = clamp(baseRange[0] + ageAdjustment + energyAdjustment, 0.8, 2.5);
      let maxFactor = clamp(baseRange[1] + ageAdjustment + energyAdjustment, minFactor + 0.1, 2.6);

      const minProtein = Math.round(calculationWeight * minFactor);
      const maxProtein = Math.round(calculationWeight * maxFactor);
      const targetProtein = Math.round((minProtein + maxProtein) / 2);
      const perMealLow = Math.round(targetProtein / 5);
      const perMealHigh = Math.round(targetProtein / 3);

      if (outputRange) outputRange.textContent = `${minProtein}-${maxProtein} g`;
      if (outputTarget) outputTarget.innerHTML = `Hyvä käytännön tavoite voisi olla <strong>${targetProtein} g proteiinia päivässä</strong>, jaettuna 3-5 aterialle.`;
      if (outputPerMeal) outputPerMeal.textContent = `${perMealLow}-${perMealHigh} g`;
      if (outputPerKg) outputPerKg.textContent = `${minFactor.toFixed(1)}-${maxFactor.toFixed(1)} g/kg`;
      if (outputCalories) outputCalories.textContent = `${Math.round(tdee / 50) * 50} kcal`;
      if (outputNote) outputNote.textContent = note;
    }

    form.addEventListener('input', calculate);
    form.addEventListener('change', calculate);
    calculate();
  });
});
